import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, tap, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CriarRecadastramentoResponseDto } from '../../colaborador/models/Criar.Recadastramento.Response.Dto';

@Injectable({
  providedIn: 'root'
})
export class ConsumidorService {
  private apiUrl = `${environment.cedaeapp}/consumidor`;

  constructor(private http: HttpClient) { }


  consultarConsumidorPorId(idjuncao: string): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/buscasdetalhadas/recente-por-idjuncao/${idjuncao}`;

    return this.http.get<any>(url, { headers }).pipe(
      tap(response => console.log('✅ consumidor:', response)),
      catchError(err => {
        throw err;
      })
    );
  }

  consultarTodosMaisRecentes(
    pagina: number = 1,
    tamanhoPagina: number = 10,
    nome?: string,
    cpf?: string,
    matricula?: string,
    status: string = 'Validado'
  ): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    let params = new HttpParams()
      .set('Pagina', pagina.toString())
      .set('TamanhoPagina', tamanhoPagina.toString());
    if (nome && nome.trim() !== '') {
      params = params.set('Nome', nome.trim());
    }
    if (cpf && cpf.trim() !== '') {
      params = params.set('CPF', cpf.trim());
    }
    if (matricula && matricula.trim() !== '') {
      params = params.set('Matricula', matricula.trim());
    }
    if (status && status.trim() !== '') {
      params = params.set('Status', status.trim());
    }

    const url = `${environment.cedaeapp}/buscasdetalhadas/todos-mais-recentes`;

    return this.http.get<any>(url, { headers, params }).pipe(
      tap(response => {
      }),
      map(response => {
        if (!response || !response.itens) {
          console.warn('Resposta da API não contém propriedade itens:', response);
          return { itens: [], totalItens: 0, paginaAtual: pagina, totalPaginas: 0, tamanhoPagina };
        }
        return response;
      }),
      catchError(err => {
        console.error('❌ Erro ao buscar registros mais recentes:', err);
        throw err;
      })
    );
  }

  consultarConsumidormatricula(matricula: string): Observable<CriarRecadastramentoResponseDto> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/buscasdetalhadas/recente-por-matricula/${matricula}`;

    return this.http.get<CriarRecadastramentoResponseDto>(url, { headers }).pipe(
      tap(response => console.log('✅ cadastro:', response)),
      catchError(err => {
        console.error('❌ Erro ao consultar consumidor:', err);
        throw err;
      })
    );
  }

  deletarPorIdJuncao(idJuncao: string, usuarioId: String): Observable<void> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.cedaeapp}/exclusao/excluirporjuncao/${idJuncao}/usuario/${usuarioId}`;

    return this.http.delete<void>(url, { headers }).pipe(
      tap(() => console.log(`✅ Registro com ID de junção ${idJuncao} deletado com sucesso.`)),
      catchError(err => {
        console.error('❌ Erro ao deletar por ID de junção:', err);
        throw err;
      })
    );
  }

  editarConsumidor(recadastroId: string, formData: FormData): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const url = `${environment.cedaeapp}/recadastro/atualizar/${recadastroId}`;

    return this.http.put<any>(url, formData, { headers }).pipe(
      catchError(err => {
        console.error('❌ Erro ao atualizar Consumidor:', err);
        throw err;
      })
    );
  }

  /**
   * Consulta os dados de auditoria com base nos parâmetros fornecidos
   * @param usuarioId ID do usuário (opcional)
   * @param entidade Tipo de entidade (opcional)
   * @param nome Nome do usuário ou entidade (opcional)
   * @param acao Tipo de ação realizada (opcional)
   * @param dataInicio Data inicial para o filtro (opcional)
   * @param dataFim Data final para o filtro (opcional)
   * @param page Número da página (padrão: 1)
   * @param pageSize Tamanho da página (padrão: 20)
   * @returns Observable com os dados de auditoria paginados
   */
  consultarAuditoria(
    usuarioId?: string,
    entidade?: string,
    nome?: string,
    acao?: string,
    dataInicio?: string,
    dataFim?: string,
    page: number = 1,
    pageSize: number = 20
  ): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    // Ajustar horas dos parâmetros de data
    let dataInicioAjustada = dataInicio;
    if (dataInicioAjustada) {
      // Extrai apenas a data (YYYY-MM-DD) e concatena 00:00:00
      const data = dataInicioAjustada.split('T')[0];
      dataInicioAjustada = `${data}T00:00:00`;
    }
    let dataFimAjustada = dataFim;
    if (dataFimAjustada) {
      // Extrai apenas a data (YYYY-MM-DD) e concatena 23:59:00
      const data = dataFimAjustada.split('T')[0];
      dataFimAjustada = `${data}T23:59:00`;
    }

    // Configurar parâmetros de consulta
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    // Adicionar parâmetros opcionais apenas se estiverem definidos
    if (usuarioId) params = params.set('usuarioId', usuarioId);
    if (entidade) params = params.set('entidade', entidade);
    if (nome) params = params.set('nome', nome);
    if (acao) params = params.set('acao', acao);
    if (dataInicioAjustada) params = params.set('dataInicio', dataInicioAjustada);
    if (dataFimAjustada) params = params.set('dataFim', dataFimAjustada);

    const url = `${environment.cedaeapp}/auditoria`;

    return this.http.get(url, { headers, params }).pipe(
      catchError(err => {
        if (err.status === 404) {
          return of({
            itens: [],
            totalItens: 0,
            paginaAtual: page,
            totalPaginas: 0,
            tamanhoPagina: pageSize
          });
        }
        console.error('❌ Erro ao consultar dados de auditoria:', err);
        throw err;
      })
    );
  }

  uploadAssinaturaVistoriante(cadastroId: string, file: File): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();
    formData.append('file', file);

    const url = `${environment.cedaeapp}/assinaturas/vistoriante/${cadastroId}/upload`;

    return this.http.post<any>(url, formData, { headers }).pipe(
      tap(() => console.log('✅ Assinatura do vistoriador enviada com sucesso.')),
      catchError(err => {
        console.error('❌ Erro ao enviar assinatura do vistoriador:', err);
        throw err;
      })
    );
  }

  uploadAssinaturaAcompanhante(cadastroId: string, file: File): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const formData = new FormData();
    formData.append('file', file);

    const url = `${environment.cedaeapp}/assinaturas/acompanhante/${cadastroId}/upload`;

    return this.http.post<any>(url, formData, { headers }).pipe(
      tap(() => console.log('✅ Assinatura do acompanhante enviada com sucesso.')),
      catchError(err => {
        console.error('❌ Erro ao enviar assinatura do acompanhante:', err);
        throw err;
      })
    );
  }
}
